export const DialogPlusIcon = ({className, small}: {className?: string; small?: boolean}) => {
  return (
    <div className={className || ""}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={small ? 12 : 24}
        height={small ? 12 : 24}
        fill="currentColor"
        viewBox="0 0 16 16"
        version="1.1"
        id="svg835"
      >
        <defs id="defs839" />
        <path
          id="path833"
          d="M 8 1 C 3.582 1 0 4.134 0 8 C 0 9.76 0.74370312 11.369609 1.9707031 12.599609 C 1.8737031 13.615609 1.5532188 14.730406 1.1992188 15.566406 C 1.1202188 15.752406 1.2736562 15.959734 1.4726562 15.927734 C 3.7286562 15.557734 5.0693438 14.989359 5.6523438 14.693359 A 9.06 9.06 0 0 0 8 15 C 12.418 15 16 11.866 16 8 C 16 4.134 12.418 1 8 1 z M 7.9882812 4 A 0.5 0.5 0 0 1 8 4 A 0.5 0.5 0 0 1 8.5 4.5 L 8.5 7.5 L 11.5 7.5 A 0.5 0.5 0 0 1 11.5 8.5 L 8.5 8.5 L 8.5 11.5 A 0.5 0.5 0 0 1 7.5 11.5 L 7.5 8.5 L 4.5 8.5 A 0.5 0.5 0 0 1 4.5 7.5 L 7.5 7.5 L 7.5 4.5 A 0.5 0.5 0 0 1 7.9882812 4 z "
        />
      </svg>
    </div>
  )
}
